import { deleteEventService } from "../infrastructure/services/deleteEventService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const deleteEvent = {
  async execute(): Promise<void> {
    await deleteEventService.execute(await tokenValidation.execute());
  },
};
